import {sanitizeBrief} from "./product-brief-schema";

export const PRODUCT_BRIEF_JSON_TYPE = "zofino-product-brief";
export const PRODUCT_BRIEF_JSON_SCHEMA_VERSION = 1;

export function createProductBriefJsonExport(brief) {
    return {
        type: PRODUCT_BRIEF_JSON_TYPE,
        schemaVersion: PRODUCT_BRIEF_JSON_SCHEMA_VERSION,
        exportedAt: new Date().toISOString(),
        brief: sanitizeBrief(brief),
    };
}

export function downloadProductBriefJson(brief) {
    const payload = createProductBriefJsonExport(brief);
    const blob = new Blob([JSON.stringify(payload, null, 2)], {type: "application/json;charset=utf-8"});
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = buildExportFileName(payload.brief);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}

export function parseProductBriefJsonFileText(text) {
    let parsed;
    try {
        parsed = JSON.parse(text);
    } catch (error) {
        return {success: false, errorKey: "pbb-json-import-invalid-json"};
    }

    if (!parsed || typeof parsed !== "object") {
        return {success: false, errorKey: "pbb-json-import-invalid-format"};
    }

    if (parsed.type !== PRODUCT_BRIEF_JSON_TYPE) {
        return {success: false, errorKey: "pbb-json-import-invalid-type"};
    }

    if (parsed.schemaVersion !== PRODUCT_BRIEF_JSON_SCHEMA_VERSION) {
        return {success: false, errorKey: "pbb-json-import-invalid-version"};
    }

    if (!parsed.brief || typeof parsed.brief !== "object" || Array.isArray(parsed.brief)) {
        return {success: false, errorKey: "pbb-json-import-missing-brief"};
    }

    return {success: true, brief: sanitizeBrief(parsed.brief)};
}

function buildExportFileName(brief) {
    const featureSlug = slugify(brief.featureName) || "draft";
    const date = new Date().toISOString().slice(0, 10);
    return `zofino-product-brief-${featureSlug}-${date}.json`;
}

function slugify(value) {
    return String(value || "")
        .trim()
        .toLowerCase()
        .replace(/[\s_]+/g, "-")
        .replace(/[^\u0600-\u06FFa-z0-9-]/g, "")
        .replace(/-+/g, "-")
        .replace(/^-|-$/g, "");
}
